<template>
	<div class="comp">
		<div class="compContent">
			<div class="title">
				<div class="titleL">编辑医疗服务</div>
				<div class="titleR">
					<el-button type="warning" plain size="small" @click="back">返回</el-button>
				</div>
			</div>
			<div class="content">
				<div class="msg">
					<div class="msgItem" >
						<div class="label">顾客名称:</div>
						<div class="value">
							{{detail.memberName}}
						</div>
					</div>
					<div class="msgItem">
						<div class="label">手机号:</div>
						<div class="value">
							{{detail.memberMobile}}
						</div>
					</div>
					<div class="msgItem" >
						<div class="label">项目:</div>
						<div class="value">
							{{detail.serviceTypeId==1?'疫苗':'驱虫'}}
						</div>
					</div>
					<div class="msgItem" style="width:33%;">
						<div class="label">套餐:</div>
						<div class="value">
							{{detail.medicalServiceName}}
						</div>
					</div>
					<div class="msgItem">
						<div class="label">宠物昵称:</div>
						<div class="value">
							{{detail.petName}}
						</div>
					</div>
					<div class="msgItem">
						<div class="label">品种:</div>
						<div class="value">
							{{detail.typeName}}
						</div>
					</div>
					<div class="msgItem" >
						<div class="label">年龄:</div>
						<div class="value">
							<span v-if="detail.birthDay">
								{{$public.FAge(new Date(detail.birthDay).getTime())[0]+'岁'+$public.FAge(new Date(detail.birthDay).getTime())[1]+'月'}}
							</span>
						</div>
					</div>
					<div class="msgItem" >
						<div class="label">性别:</div>
						<div class="value">
							{{detail.sex}}
						</div>
					</div>
					<div class="msgItem">
						<div class="label">创建人:</div>
						<div class="value">
							{{detail.createUserName}}
						</div>
					</div>
					<div class="msgItem">
						<div class="label">创建时间:</div>
						<div class="value">
							{{$public.FTime(detail.createTime)}}
						</div>
					</div>
					<div class="msgItem">
						<div class="label">支付方式:</div>
						<div class="value">
							<span style="line-height:32px;">全额支付</span>
						</div>
					</div>
					<div class="msgItem">
						<div class="label">完成时间:</div>
						<div class="value">
							{{$public.FTime(detail.handlerTime)}}
						</div>
					</div>
				</div>
				<div class="relation">
					<div class="relationTitLine">
						<div style="line-height: 40px;">套餐明细</div>
						<div>
						</div>
					</div>
					<el-table border :data="detail.serviceGoods" ref="table">
						<el-table-column width="40">
							<template slot-scope="props">
								<el-checkbox v-model="selectedArr[props.$index]" :disabled="!!props.row.orderNum||(props.row.canDelete===false)" @change="changeTotal(arguments[0],'selectGoods')"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column label="名称" prop="goodsName" min-width="150">
							<template slot-scope="props">
								{{props.row.dosageCeiling===1?'[ 整 ] ':''}}
								{{props.row.goodsName}}
								<span v-if="props.row.replaceType===2" style="color:#FDD000">(换)</span>
							</template>
						</el-table-column>
						<el-table-column label="规格" prop="skuValue" min-width="80">
						</el-table-column>
						<el-table-column label="数量" prop="num" min-width="100">
							<template slot-scope="props">
								<el-input
								disabled
								v-model="props.row.num"
								style="width:70px">
								</el-input>
							</template>
						</el-table-column>
						<el-table-column label="单位" prop="unit" min-width="60">
						</el-table-column>
						<el-table-column label="出库量" min-width="140">
							<template slot-scope="props">
								<div class="cishu">
									<el-input
									disabled
									v-model="props.row.goodsDosage"
									style="width:100px;">
										<template slot="append" style="padding:0;">{{props.row.outUnit}}</template>
									</el-input>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="单价" prop="originalPrice" min-width="60">
						</el-table-column>
						<el-table-column label="换算单位" min-width="90">
							<template slot-scope="props">
								{{props.row.unit_changesrc}}={{props.row.unit_changedesc}}
							</template>
						</el-table-column>
						<el-table-column label="库存" min-width="100">
							<template slot-scope="props" >
								<span v-if="props.row.skuStocks&&props.row.skuStocks.length>0">
									{{$public.getMatchingItem(props.row.skuStocks[props.row.skuValueIndex].lstStock,'shopId',curShopId).stock}}
								</span>
								<span v-else>--</span>
							</template>
						</el-table-column>
						<el-table-column label="支付状态" min-width="70">
							<template slot-scope="props">
								<span v-if="props.row.isPay" style="color:#18A44C">已支付</span>
								<span v-else>
									<span v-if="props.row.orderNum" style="color:#FDD000">待支付</span>
									<span v-if="!props.row.orderNum" style="color:red;">未支付</span>
								</span>
							</template>
						</el-table-column>
						<el-table-column label="小计" min-width="90">
							<template slot-scope="props">
								{{$public.getSubtotal(props.row)}}
							</template>
						</el-table-column>
						<el-table-column label="是否补差价" min-width="90">
							<template slot-scope="props" v-if="props.row.replaceType===2">
								<el-switch disabled :value="!props.row.notCount" >
								</el-switch>
							</template>
						</el-table-column>
					</el-table>
					<div style="text-align: center;margin:30px 0 0;padding-bottom:30px;">
						<span v-if="orderNumber!==''">
							有未支付订单
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="settlement">
			<div class="settlementL">
				<span>共计：</span><span style="font-size: 16px;margin-right: 40px;">{{totalMoney.count}}件</span>
				<span>套餐计划价：</span><span style="font-size: 16px;margin-right: 40px;">￥{{detail.packageMoney}}</span>
				<span>小计：</span><span style="font-size: 16px;margin-right: 40px;">￥{{totalMoney.total}}</span>
				<span style="color:#18A44C">已支付：</span><span style="font-size: 16px;color:#18A44C;margin-right: 40px;">￥{{totalMoney.paid}}</span>
				<span style="color:red">待支付：</span><span style="font-size: 16px;color:red;margin-right: 50px;">
					￥{{totalMoney.unpaid}}
				</span>
			</div>
			<div class="settlementR">
				<span>总计：</span><span style="font-size: 16px;margin-right:20px;">￥{{totalMoney.unpaid}}</span>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				dialogShouyin_state:false,
				shouyinData:[],
				
				orderNumber:'',
				codeUrl:'',
				dialogChangeGoods_state:false,
				dialogComplete_state:false,
				
				propsId:'',
				propsRow:'',
				
				detail:{},
				
				selectedArr:[],
				
				totalMoney:{},
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
			ylfwParams(){
				return this.$store.state.yiliaoxin.ylfwParams;
			},
		},
		mounted(){
			this.getDetail('mounted')
		},
		methods: {
			// 返回
			back(){
				this.$store.commit("yiliaoxin/remove_router")
				if(this.$store.state.yiliaoxin.router.length===0){
					this.ylfwParams.type = 'list'
					this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
					this.$store.commit('yiliaoxin/set_curBusiness','医疗服务')
				}
				// if(
				// 	this.$store.state.yiliaoxin.curBusinessPre==='工作台'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rBingli'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rYmqc'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rZhuyuan'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenDai'||
				// 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenZhong'
				// ){
				// 	this.$store.commit('yiliaoxin/set_curBusiness',this.$store.state.yiliaoxin.curBusinessPre)
				// 	return 
				// }
				// this.ylfwParams.type = 'list'
				// this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
			},
			changeTotal(e,str,row,type){
				if(str=='selectGoods'){
					this.getTotal();
				}else if(str=='changeNum'){
					if(type=='blur'&&row.num==='') row.num=1;
					row.num = this.$public.replaceGoodsDosage(row.num)
					if(row.goodsType===1){
						let stock = this.$public.getMatchingItem(row.skuStocks[row.skuValueIndex].lstStock,'shopId',this.curShopId).stock;
						let totalTimes = this.$public.getMatchingItem(row.skuStocks[row.skuValueIndex].lstStock,'shopId',this.curShopId).totalTimes
						if(row.num>stock){
							this.$message({
								message: '该药品最大数量为'+stock,
								type: 'error'
							});
							row.num=stock;
						}
						let goodsDosage = this.$public.cheng(row.num,row.in_exchanage)
						if(goodsDosage>totalTimes){
							row.goodsDosage = totalTimes
						}else{
							row.goodsDosage = goodsDosage;
						}
					}
					if(row.num!==''){
						let params = {
							"itemsId": row.itemsId,
							"num": Number(row.num),
							allowWholesale:row.allow_wholesale,
							goodsDosage:Number(row.goodsDosage)
						}
						this.$http.post('/api/MedicalService/UpdateNum', params).then(res => {
							if (res.code == 0) {
								console.log('修改数量成功')
							}
							this.getDetail();
						})
					}
				}else if(str=='chajia'){
					this.getTotal();
				}else if(str=="changeGoodsDosage"){
					row.goodsDosage = this.$public.replaceGoodsDosage(row.goodsDosage)
					let totalTimes = this.$public.getMatchingItem(row.skuStocks[row.skuValueIndex].lstStock,'shopId',this.curShopId).totalTimes
					if(row.goodsDosage>totalTimes){
						this.$message({
							message: '该药品最大用量为'+totalTimes,
							type: 'error'
						});
						row.goodsDosage = totalTimes;
					}
					let num = Math.ceil(this.$public.chu(Number(row.goodsDosage),row.in_exchanage))
					row.num = num;
					if(type=='blur'&&row.goodsDosage==='') row.goodsDosage=1;
					if(row.goodsDosage!==''){
						let params = {
							"itemsId": row.itemsId,
							"num": Number(row.num),
							allowWholesale:row.allow_wholesale,
							goodsDosage:Number(row.goodsDosage)
						}
						this.$http.post('/api/MedicalService/UpdateNum', params).then(res => {
							if (res.code == 0) {
								console.log('修改用量成功')
							}
							this.getDetail();
						})
					}
				}
			},
			// 计算总价
			getTotal(){
				let total = {delPaid:0,paid:0,unpaid:0,total:0,count:0}
				for(let a=0;a<this.selectedArr.length;a++){
					let goods = this.detail.serviceGoods[a];
					let N = goods.allowWholesale===0?goods.countPriceDosage:goods.num;
					if(this.selectedArr[a]){  // 选中的计划
						if(goods===undefined){
							this.selectedArr.splice(a,1)
						}else{ 
							total.count = total.count + 1;
							total.total = this.$public.jia(total.total,this.$public.cheng(N,goods.price))
						}
					}
				}
				
				let replaceObj = {}
				for(let c=0;c<this.detail.serviceGoodsAll.length;c++){
					let goods = this.detail.serviceGoodsAll[c];
					let N = goods.allowWholesale===0?goods.countPriceDosage:goods.num;
					if(goods.replaceType===0&&goods.isPay!==true){ // replaceType===0 并且 未支付的金额
						total.unpaid = this.$public.jia(total.unpaid,this.$public.cheng(N,goods.price))
					}
					if(goods.isPay===true){  // 已支付
						if(goods.replaceType===0){  //  没有进行替换的
							total.paid = this.$public.jia(total.paid,this.$public.cheng(N,goods.price))
						}else if(goods.replaceType===1){
							if(goods.notCount==false){
								total.paid = this.$public.jia(total.paid,this.$public.cheng(N,goods.price))
							}else{
								var findItems = this.detail.serviceGoodsAll.find((m) =>{return m.replaceMark === goods.id && m.isPay === true});
								if(findItems===undefined){
									total.paid = this.$public.jia(total.paid,this.$public.cheng(N,goods.price))
								}
							}
						}else if(goods.replaceType===2){
							if(goods.notCount===false){
								total.paid = this.$public.jia(total.paid,this.$public.cheng(N,goods.price))
							}
						}
					}
					if(!this.$public.isNull(goods.replaceMark)&&goods.isPay!==true){
						if(replaceObj[goods.replaceMark]==undefined){
							replaceObj[goods.replaceMark] = [0,0]
							replaceObj[goods.replaceMark][1] = this.$public.cheng(goods.price,N);
						}else{
							replaceObj[goods.replaceMark][1] = this.$public.jia(replaceObj[goods.replaceMark][1],this.$public.cheng(goods.price,N)<0?0:this.$public.cheng(goods.price,N))
						}
					}
				}
				for(let k in replaceObj){
					let goods = this.detail.serviceGoodsAll.find((item)=>{return item.id===k}); // 被替换的商品
					let N = goods.allowWholesale===0?goods.countPriceDosage:goods.num;
					replaceObj[k][0] = this.$public.cheng(goods.price,N)
					replaceObj[k][2] = goods.notCount;
					if(replaceObj[k][2]===true){ // 补差价
						total.unpaid = this.$public.jia(total.unpaid,this.$public.jian(replaceObj[k][1],replaceObj[k][0]))
						total.delPaid = this.$public.jia(total.delPaid,replaceObj[k][0])
					}
				}
				this.totalMoney = total;
			},
			// 获取详情
			getDetail(str){
				this.$http.get('/api/MedicalService/Detail', {id:this.ylfwParams.curRow.id}).then(res => {
					if (res.code == 0) {
						if(res.data.serviceGoods==null){
							res.data.serviceGoods = []
							this.selectedArr = []
						}
						res.data.serviceGoodsAll = res.data.serviceGoods
						res.data.serviceGoods = this.filterPlanGoods(res.data.serviceGoods)
						if(str=='mounted'){
							this.selectedArr=[]
							for(let i=0;i<res.data.serviceGoods.length;i++){
								this.selectedArr.push(true)
							}
						}else{
							for(let i=0;i<res.data.serviceGoods.length;i++){
								if(this.selectedArr[i]===undefined){
									this.selectedArr.push(true)
								}
							}
						}
						let arr = []
						for(let i=0;i<res.data.serviceGoods.length;i++){
							arr.push(res.data.serviceGoods[i])
						}
						if(arr.goodsType==1){
						this.$util.getGoodsInfo(arr).then(goodsList=>{
							for(let i=0;i<goodsList.length;i++){
								goodsList[i].allow_wholesale = goodsList[i].allowWholesale
								this.$set(goodsList[i],'skuValueIndex',0)
								goodsList[i].skuStocks = goodsList[i].skuStocks||[]
								for(let a=0;a<goodsList[i].skuStocks.length;a++){
									if(goodsList[i].skuValue==goodsList[i].skuStocks[a].skuValue){
										this.$set(goodsList[i],'skuValueIndex',a)
										// this.$set(goodsList[i],'originalPrice',goodsList[i].skuStocks[a].salePrice)
										this.$set(goodsList[i],'skus',goodsList[i].skuStocks[a].skus)
										this.$set(goodsList[i],'skuValue',goodsList[i].skuStocks[a].skuValue)
									}
								}
							}
							
						})
					}
					this.detail = res.data;
							this.$nextTick(()=>{
								this.getTotal();
							})
							this.getPayAddr(this.detail.id)
					}
				})
			},
			// 过滤
			filterPlanGoods(arr){
				let arr1 = []
				for(let i=0;i<arr.length;i++){
					if(arr[i].replaceType!==1){ // 有更换的商品
						arr1.push(arr[i])
					}
				}
				return arr1
			},
		}
	}
</script>
<style scoped lang="scss">
	.comp{
		position: relative;height: 100%;padding-bottom:68px;box-sizing: border-box;
		.compContent{
			height: 100%;background-color: #fff;border-radius: 12px;overflow: auto;
			.title{
				display: flex;height: 47px;line-height: 27px;border-bottom:1px solid #f2f2f2;padding:10px 18px;box-sizing: border-box;
				.titleL{
					width:50%;font-size: 14px;font-weight: bold;
				}
				.titleR{
					width:50%;text-align: right;
					.titleRText{
						display: inline-block;font-size: 14px;color:$mainColor;margin-left: 40px;cursor: pointer;
					}
				}
			}
			.content{
				height: calc(100% - 47px);overflow: auto;
				.msg{
					display: flex;flex-wrap: wrap;padding-top:10px;
					.msgItem{
						width:22%;display: flex;padding:5px 0;
						.label{
							font-size: 14px;color:$fontColor;width:100px;text-align: right;line-height: 32px;margin-right: 4px;
						}
						.value{
							font-size: 14px;color:$fontColor;line-height: 32px;
						}
					}
				}
				.relation{
					padding:10px 0 8px;
					.relationTitLine{
						display: flex;justify-content: space-between;font-size: 14px;color:$fontColor;padding:0 18px 10px;font-weight: bold;
					}
					height: calc(100% - 140px);
				}
			}
		}
		.settlement{
			position: absolute;bottom:0;width:100%;height:56px;background-color: #fff;border-radius: 12px 12px 0 0;display: flex;padding:12px 20px;box-sizing: border-box;
			.settlementL{
				width:70%;font-size: 14px;line-height: 32px;
			}
			.settlementR{
				width:30%;text-align: right;font-size: 14px;line-height: 32px;
				.text{
					color:$fontColor;font-size: 14px;padding:0px 24px 0;display: inline-block;margin-right: 20px;
				}
			}
			
		}
	}
</style>
